import { Suspense, lazy } from "react";

// Loaded on demand: the page uses the platform's settings parts, which the
// package entry must not import.
const Page = lazy(() => import("./CollectionSettings").then((m) => ({ default: m.CollectionSettings })));

/** Project → Settings → Collection, in the Labeling section of the menu. */
export const CollectionSettingsPage = (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

CollectionSettingsPage.title = "Collection";
CollectionSettingsPage.path = "/collection";
CollectionSettingsPage.exact = true;
CollectionSettingsPage.menuSection = "labeling";
